import {
  Navbar,
  Nav,
  NavItem,
} from "reactstrap";
import {
  Link,
  // NavLink as RRNavLink 
} from "react-router-dom";
import { useContext, useState } from "react";
import { SchoolContext } from "../context/SchoolContext";
import { useHistory } from "react-router-dom";
import { Notification } from "./Logo";
import { NotificationModal } from "./BaseModal";

const NavMenu = (props) => {

  const { message } = useContext(SchoolContext);
  const history = useHistory();
  const [openModal, setOpenModal] = useState(false);

  const closeModal = () => {
    setOpenModal(false)
  };

  const pathname = history["location"].pathname
  const school_id = Number(pathname.split('/').pop());

  return (
    <>

      <NotificationModal
        open={openModal}
        content={
          message && message.length > 0 ? message.map((data) => {
            return (
              <>
                <div className="mt-2 px-2">
                  <span>{data.target_time}</span> <br />
                  <span>{data.title}</span> <br />
                  <span>{data.content}</span>
                </div>
              </>
            )
          }) : "現在通知はありません。"
        }
        handleOpen={closeModal}
        modalStyle="modal-content1"
      />

      <Navbar id="topnavMobile">
        <div>
          <Nav>
            <NavItem>
              <Link to="/home"
                onClick={() => {
                  // localStorage.removeItem('curr_school');
                  // setTimeout(() => {
                  //   window.location.reload();
                  // })
                }}
              // className="cursorPoint"
              >
                <img src="/img/logo.png" alt="logo" className="logo" />
              </Link>
            </NavItem>

            {!Number.isNaN(school_id) && school_id > 0 ?

              <NavItem onClick={() => setOpenModal(true)}>
                <Notification />
                {/* {message && message.data.length > 0 ? <div className="notification">
                  <span> {message.data.length}</span>
                </div> : ""} */}
              </NavItem>

              : ""}
          </Nav>
        </div>
      </Navbar>

    </>
  );
};

export default NavMenu;



























